"use client";

import { useState } from "react";
import { Box, Typography, styled, Chip } from "@mui/material";
import {
  RightColumn,
  SectionHeader,
  SectionContent,
  Label,
  Value,
} from "./styles/SharedStyles";
import EditCulture from "../modals/EditCulture";
import EditButton from "@components/shared/EditButton";
import { SummarySkeleton } from "./skeletons/SummarySkeleton";

const CultureSection = styled(Box)(({ theme }) => ({
  width: "85%",
  display: "flex",
  gap: "8px",
  marginBottom: theme.spacing(3),
  "&:last-child": {
    marginBottom: 0,
  },
}));

const CultureFitChips = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
  marginTop: "4px",
}));

const Culture = ({ candidate, onUpdate, isImporting }) => {
  const [openEditCulture, setOpenEditCulture] = useState(false);

  return (
    <>
      <Box>
        <SectionContent>
          <EditButton onEdit={() => setOpenEditCulture(true)} sx={{ top: 0, right: 0 }} />
          <Box>
            <RightColumn>
              <SectionHeader>
                <Typography variant="h2">Culture & Personality</Typography>
              </SectionHeader>

              {isImporting ? (
                <SummarySkeleton />
              ) : (
                <>
                  <CultureSection>
                    <Label>Personality Summary:</Label>
                    <Value>{candidate.personality_summary || 'Not analyzed yet'}</Value>
                  </CultureSection>

                  <CultureSection>
                    <Label>Work Style:</Label>
                    <Value>{candidate.work_style || 'Not analyzed yet'}</Value>
                  </CultureSection>

                  <CultureSection>
                    <Label>Personal Story:</Label>
                    <Value>{candidate.personal_story || 'Not analyzed yet'}</Value>
                  </CultureSection>
                </>
              )}
            </RightColumn>
          </Box>
        </SectionContent>
      </Box>
      
      {openEditCulture && (
        <EditCulture
          open={openEditCulture}
          candidate={candidate}
          onClose={() => setOpenEditCulture(false)}
          onSave={onUpdate}
        />
      )}
    </>
  );
};

export default Culture;